var _rect, _rect2, _g, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloaticonarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 101,
    fill: "none",
    viewBox: "0 0 92 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91.422,
    height: 100.833,
    fill: "#fff",
    fillOpacity: 0.15,
    rx: 10.756
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 75.289,
    height: 75.289,
    x: 8.066,
    y: 12.773,
    fill: "#F2F1FF",
    rx: 5.378
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M25.655 61.562a2.348 2.348 0 0 0 1.631-.636l10.388-9.719a.783.783 0 0 1 1.092 0l3.474 3.49a5.642 5.642 0 0 0 7.795 0l5.789-5.773a.39.39 0 0 1 .554 0l2.772 2.756a1.518 1.518 0 0 0 1.11.457c.206 0 .41-.038.602-.114a1.63 1.63 0 0 0 .963-1.452v-9.458a1.63 1.63 0 0 0-1.631-1.63h-9.377a1.63 1.63 0 0 0-1.109 2.69l2.773 2.756a.374.374 0 0 1 .114.277.343.343 0 0 1-.114.277l-5.822 5.838a.816.816 0 0 1-1.109 0l-3.49-3.49a5.463 5.463 0 0 0-7.648-.065l-10.371 9.785a2.348 2.348 0 0 0-.098 3.261 2.3 2.3 0 0 0 1.712.75Z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 91.161,
    height: 100.572,
    x: 0.131,
    y: 0.131,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 0.262,
    rx: 10.625
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h38.493v38.493H0z",
    transform: "translate(23.332 31.275)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloaticonarrow);
export default __webpack_public_path__ + "static/media/float icon arrow.22b47bd5c178ea1ebbf0a66f166174b3.svg";
export { ForwardRef as ReactComponent };